import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { routes } from 'config/routes';

class RedirectLanding extends Component {
  componentDidMount() {
    const inDevEnv = window.location.href.includes('.dev');
    if (process.env.NODE_ENV === 'production' && !inDevEnv) {
      window.location.replace('https://www.triider.com.br/imobiliarias');
    } else {
      const { _push } = this.props;
      _push(routes.home);
    }
  }

  render() {
    return <div />;
  }
}

export default connect(
  null,
  { _push: push },
)(RedirectLanding);
